import { render, staticRenderFns } from "./BlogsTable.vue?vue&type=template&id=48af3114"
import script from "./BlogsTable.vue?vue&type=script&lang=js"
export * from "./BlogsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports